import { Vector2 } from 'three'
import EventEmitter from './EventEmitter'

export default class Sizes extends EventEmitter
{
    constructor()
    {
        super()

        this.resize = this.resize.bind(this)
        window.addEventListener('resize', this.resize)

        this.resize()
    }

    resize()
    {
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.windowHalf = new Vector2(window.innerWidth / 2, window.innerHeight / 2)
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        this.trigger('resize')
    }
}